import ApiClient from '@/helpers/api/api.helpers';

class QueuesData extends ApiClient {
  constructor() {
    super('reports/elements');
  }
}

export default new QueuesData();
